var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTopNews = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 859 333",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M859 0V332.667H360V0H859ZM91 170H0V157H91V170ZM253.5 145H0V132H253.5V145ZM338 125H0V112H338V125ZM344.5 105H0V92H344.5V105ZM200 80.25H0V60.25H200V80.25ZM330 52.25H0V32.25H330V52.25ZM270 24.25H0V4.25H270V24.25Z",
  fill: "#DFDFDF"
})));
export default SvgTopNews;